export default __webpack_public_path__ + "static/media/CreditCardActive2.efd4fe3f.svg";